<script setup lang="ts"></script>

<template>
    <div class="flex flex-col text-center w-full px-[10%]">
        <div class="flex flex-row w-full">
            <div class="flex pr-2">
                <img
                    class="w-[50px] h-[50px] min-w-[50px]"
                    :src="'/img/quote-open.png'"
                    alt="Open quote"
                />
            </div>
            <div class="flex grow text-2xl lg:text-4xl font-bold py-6.25 leading-normal">
                Preno helped us increase occupancy rates from 35% to 75%
            </div>
            <div class="flex flex-col-reverse pl-2">
                <img
                    class="rotate-180 w-[50px] h-[50px] min-w-[50px]"
                    :src="'/img/quote-open.png'"
                    alt="Close quote"
                />
            </div>
        </div>
        <div
            class="flex flex-row w-full text-center font-bold text-[1.25rem] py-12.5 justify-center"
        >
            Tongariro Crossing Lodge, NZ - Louis van Wyk
        </div>
        <div class="flex flex-row justify-center w-full">
            <div
                class="flex flex-row w-[60%] bg-white py-[25px] px-[15px] rounded-lg border-[#FAE6C6] border min-w-[310px]"
            >
                <div class="flex flex-col items-center w-[45%] justify-center">
                    <img
                        class="mb-2.5 h-[22px]"
                        :src="'/img/sign-up/stars.png'"
                        alt="4.7 out of 5"
                    />
                    <p class="text-[black] text-sm font-bold whitespace-nowrap">4.7 out of 5</p>
                    <p class="text-[#807C86]">Capterra</p>
                </div>
                <div class="grow flex items-center justify-center w-[10%]">
                    <Divider layout="vertical" />
                </div>
                <div class="flex flex-col items-center w-[45%] justify-center">
                    <p class="text-2xl text-[#F5A522] font-black">95%</p>
                    <p class="text-sm font-bold">recommended</p>
                    <p class="text-[#807C86]">HotelTechReport</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
